export const RESERVED_BUSINESS_SLUGS = [
  'add',
  'create',
  'new',
  'edit',
  'view',
  'delete',
  'admin',
]

export const softNormalizeSlug = value =>
  (value || '')
    .toLowerCase()
    .replace(/[^a-z0-9-]+/g, '-')
    .replace(/--+/g, '-')

export const hardNormalizeSlug = value =>
  softNormalizeSlug(value).replace(/^-+|-+$/g, '')
